import { ShippingAccount } from '../../../containers/orders-filter-bar-container/filter-options/options/shipping-account/shipping-account';
import { BillToParty } from '../../../containers/orders-filter-bar-container/filter-options/options/filter-editor/bill-to-party';

import {
  OPERATOR_TYPE_INCLUDES,
  OPERATOR_TYPE_DOES_NOT_INCLUDE,
  OPERATOR_TYPE_VALUE_ARE_EMPTY,
  OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY,
  OPERATOR_TYPE_CONTAINS,
  OPERATOR_TYPE_DOES_NOT_CONTAIN,
  OPERATOR_TYPE_STARTS_WITH,
  OPERATOR_TYPE_DOES_NOT_START_WITH,
  OPERATOR_TYPE_IS_BLANK,
  OPERATOR_TYPE_IS_NOT_BLANK,
  OPERATOR_TYPE_EQUALS,
  OPERATOR_TYPE_NOT_EQUALS,
  OPERATOR_TYPE_ENDS_WITH,
  OPERATOR_TYPE_DOES_NOT_END_WITH,
  OPERATOR_TYPE_IS_UNKNOWN,
  OPERATOR_TYPE_SHORT_EQUALS,
  OPERATOR_TYPE_SHORT_NOT_EQUALS,
  OPERATOR_TYPE_GREATER_THAN,
  OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_LESS_THAN,
  OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_CURRENT_DATE,
  OPERATOR_TYPE_WITHIN_PAST_X_DAYS,
  OPERATOR_TYPE_WITHIN_NEXT_X_DAYS,
  OPERATOR_TYPE_BEFORE_X_DAYS,
  OPERATOR_TYPE_AFTER_X_DAYS,
  OPERATOR_TYPE_ON_OR_AFTER,
  OPERATOR_TYPE_ON_OR_BEFORE,
  OPERATOR_TYPE_TIME_AT_OR_AFTER,
  OPERATOR_TYPE_TIME_AT_OR_BEFORE,
  OPERATOR_TYPE_VALUE_EQUALS_TRUE,
  OPERATOR_TYPE_VALUE_EQUALS_FALSE,
  OPERATOR_TYPE_SHIPPING_MY_ACCOUNT,
  OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT,
  OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT,
} from '../constants/filter-operator-type';

import {
  APPLIED_FILTER_OPERATOR_CONTAINS,
  APPLIED_FILTER_OPERATOR_NOT_CONTAINS,
  APPLIED_FILTER_OPERATOR_STARTS_WITH,
  APPLIED_FILTER_OPERATOR_NOT_STARTS_WITH,
  APPLIED_FILTER_OPERATOR_IS_BLANK,
  APPLIED_FILTER_OPERATOR_IS_NOT_BLANK,
  APPLIED_FILTER_OPERATOR_EQUALS,
  APPLIED_FILTER_OPERATOR_NOT_EQUALS,
  APPLIED_FILTER_OPERATOR_ENDS_WITH,
  APPLIED_FILTER_OPERATOR_NOT_ENDS_WITH,
  APPLIED_FILTER_OPERATOR_SHORT_EQUALS,
  APPLIED_FILTER_OPERATOR_SHORT_NOT_EQUALS,
  APPLIED_FILTER_OPERATOR_GREATER_THAN,
  APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO,
  APPLIED_FILTER_OPERATOR_LESS_THAN,
  APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO,
  APPLIED_FILTER_OPERATOR_CURRENT_DATE,
  APPLIED_FILTER_OPERATOR_WITHIN_PAST_X_DAYS,
  APPLIED_FILTER_OPERATOR_WITHIN_NEXT_X_DAYS,
  APPLIED_FILTER_OPERATOR_BEFORE_X_DAYS,
  APPLIED_FILTER_OPERATOR_AFTER_X_DAYS,
  APPLIED_FILTER_OPERATOR_ON_OR_AFTER,
  APPLIED_FILTER_OPERATOR_ON_OR_BEFORE,
  APPLIED_FILTER_OPERATOR_TIME_AT_OR_AFTER,
  APPLIED_FILTER_OPERATOR_TIME_AT_OR_BEFORE,
  APPLIED_FILTER_OPERATOR_EQUALS_TRUE,
  APPLIED_FILTER_OPERATOR_EQUALS_FALSE,
} from '../constants/applied-filter-operator';

const billToRecipientValue = ['1'];
const billToThirdPartiesValue = ['2'];

const filterPropsForOperatorMap = {
  [OPERATOR_TYPE_INCLUDES]: { isIn: true, isNull: undefined },
  [OPERATOR_TYPE_DOES_NOT_INCLUDE]: { isIn: false, isNull: undefined },
  [OPERATOR_TYPE_VALUE_ARE_EMPTY]: { isIn: undefined, isNull: true },
  [OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY]: { isIn: undefined, isNull: false },
  [OPERATOR_TYPE_CONTAINS]: {
    operator: APPLIED_FILTER_OPERATOR_CONTAINS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_DOES_NOT_CONTAIN]: {
    operator: APPLIED_FILTER_OPERATOR_NOT_CONTAINS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_STARTS_WITH]: {
    operator: APPLIED_FILTER_OPERATOR_STARTS_WITH,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_DOES_NOT_START_WITH]: {
    operator: APPLIED_FILTER_OPERATOR_NOT_STARTS_WITH,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_IS_BLANK]: {
    operator: APPLIED_FILTER_OPERATOR_IS_BLANK,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_IS_NOT_BLANK]: {
    operator: APPLIED_FILTER_OPERATOR_IS_NOT_BLANK,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_EQUALS]: {
    operator: APPLIED_FILTER_OPERATOR_EQUALS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_NOT_EQUALS]: {
    operator: APPLIED_FILTER_OPERATOR_NOT_EQUALS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_ENDS_WITH]: {
    operator: APPLIED_FILTER_OPERATOR_ENDS_WITH,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_DOES_NOT_END_WITH]: {
    operator: APPLIED_FILTER_OPERATOR_NOT_ENDS_WITH,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_IS_UNKNOWN]: { isIn: undefined, isNull: true },
  [OPERATOR_TYPE_SHORT_EQUALS]: {
    operator: APPLIED_FILTER_OPERATOR_SHORT_EQUALS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_SHORT_NOT_EQUALS]: {
    operator: APPLIED_FILTER_OPERATOR_SHORT_NOT_EQUALS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_GREATER_THAN]: {
    operator: APPLIED_FILTER_OPERATOR_GREATER_THAN,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO]: {
    operator: APPLIED_FILTER_OPERATOR_GREATER_THAN_OR_EQUAL_TO,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_LESS_THAN]: {
    operator: APPLIED_FILTER_OPERATOR_LESS_THAN,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO]: {
    operator: APPLIED_FILTER_OPERATOR_LESS_THAN_OR_EQUAL_TO,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_CURRENT_DATE]: {
    operator: APPLIED_FILTER_OPERATOR_CURRENT_DATE,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_WITHIN_PAST_X_DAYS]: {
    operator: APPLIED_FILTER_OPERATOR_WITHIN_PAST_X_DAYS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_WITHIN_NEXT_X_DAYS]: {
    operator: APPLIED_FILTER_OPERATOR_WITHIN_NEXT_X_DAYS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_BEFORE_X_DAYS]: {
    operator: APPLIED_FILTER_OPERATOR_BEFORE_X_DAYS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_AFTER_X_DAYS]: {
    operator: APPLIED_FILTER_OPERATOR_AFTER_X_DAYS,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_ON_OR_AFTER]: {
    operator: APPLIED_FILTER_OPERATOR_ON_OR_AFTER,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_ON_OR_BEFORE]: {
    operator: APPLIED_FILTER_OPERATOR_ON_OR_BEFORE,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_TIME_AT_OR_AFTER]: {
    operator: APPLIED_FILTER_OPERATOR_TIME_AT_OR_AFTER,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_TIME_AT_OR_BEFORE]: {
    operator: APPLIED_FILTER_OPERATOR_TIME_AT_OR_BEFORE,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_VALUE_EQUALS_TRUE]: {
    value: APPLIED_FILTER_OPERATOR_EQUALS_TRUE,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_VALUE_EQUALS_FALSE]: {
    value: APPLIED_FILTER_OPERATOR_EQUALS_FALSE,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_SHIPPING_MY_ACCOUNT]: {
    column: ShippingAccount.filterValue,
    isIn: true,
    values: undefined,
  },
  [OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT]: {
    column: BillToParty.filterValue,
    isIn: true,
    values: billToRecipientValue,
  },
  [OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT]: {
    column: BillToParty.filterValue,
    isIn: true,
    values: billToThirdPartiesValue,
  },
  [OPERATOR_TYPE_VALUE_EQUALS_TRUE]: {
    value: APPLIED_FILTER_OPERATOR_EQUALS_TRUE,
    isIn: undefined,
    isNull: undefined,
  },
  [OPERATOR_TYPE_VALUE_EQUALS_FALSE]: {
    value: APPLIED_FILTER_OPERATOR_EQUALS_FALSE,
    isIn: undefined,
    isNull: undefined,
  },
};

export const getAdjustedFilterFromOperatorTypeChange = (appliedFilter, operatorType) => {
  return {
    ...appliedFilter,
    ...filterPropsForOperatorMap[operatorType],
  };
};
